import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const productSlice = createSlice({
  name: "product",

  initialState: {
    productData: [],
    isError: false,
  },

  reducers: {
    fetchProductSuccess: (state, action) => {
      state.isError = false;
      state.productData = action.payload;
    },
    fetchProductFailure: (state) => {
      state.isError = true;
    },
  },
});

export const { fetchProductSuccess, fetchProductFailure } =
  productSlice.actions;

export const fetchProduct = () => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/product-list`);
    dispatch(fetchProductSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchProductFailure());
  }
};

export default productSlice.reducer;
